import { Product } from "@deliverr/commons-clients";
import { isEmpty } from "lodash";

export const getStorageProductDsku = (product?: Pick<Product, "dsku" | "packOf">): string | undefined => {
  return isEmpty(product?.packOf) ? product?.dsku : product!.packOf;
};
